/**
 * Rail-status normalization + status color tokens.
 *
 * `railStatus(s)` classifies a raw IRCTC passenger status string
 * (e.g. "CNF", "RAC 3", "GNWL 12", "PQWL 4", "CAN/MOD") into one of
 * five buckets used throughout the Pro Dashboard: confirmed | rac |
 * waiting | cancelled | neutral.
 *
 * `statusColor[bucket]` returns the full token set (Tailwind classes
 * AND raw hex / rgba) for that bucket — components can reach for
 * `text` + `bg` + `border` for pills, or `hex` for SVG strokes.
 *
 * Ported verbatim from
 * design_handoff_pro_dashboard/design_reference/primitives.jsx.
 */

export const railStatus = (s) => {
  const x = (s || "").toUpperCase();
  if (x.includes("CNF") || x.includes("CONFIRMED")) return "confirmed";
  if (x.includes("RAC")) return "rac";
  if (
    x.includes("WL") ||
    x.includes("PQWL") ||
    x.includes("GNWL") ||
    x.includes("RLWL") ||
    x.includes("TQWL") ||
    x.includes("WAITING")
  ) {
    return "waiting";
  }
  if (x.includes("CAN")) return "cancelled";
  return "neutral";
};

export const statusColor = {
  confirmed: {
    text: "text-emerald-400",
    bg: "bg-emerald-400/10",
    border: "border-emerald-400/25",
    dot: "bg-emerald-400",
    hex: "#34d399",
    soft: "rgba(52,211,153,.12)",
  },
  rac: {
    text: "text-amber-400",
    bg: "bg-amber-400/10",
    border: "border-amber-400/25",
    dot: "bg-amber-400",
    hex: "#fbbf24",
    soft: "rgba(251,191,36,.12)",
  },
  waiting: {
    text: "text-rose-400",
    bg: "bg-rose-400/10",
    border: "border-rose-400/25",
    dot: "bg-rose-400",
    hex: "#fb7185",
    soft: "rgba(251,113,133,.12)",
  },
  cancelled: {
    text: "text-zinc-400",
    bg: "bg-zinc-500/10",
    border: "border-zinc-500/25",
    dot: "bg-zinc-500",
    hex: "#a1a1aa",
    soft: "rgba(161,161,170,.12)",
  },
  neutral: {
    text: "text-zinc-300",
    bg: "bg-zinc-700/30",
    border: "border-zinc-700",
    dot: "bg-zinc-500",
    hex: "#a1a1aa",
    soft: "rgba(161,161,170,.12)",
  },
};

// Convenience: bucket name -> hex (for recharts strokes/fills).
export const statusHex = Object.fromEntries(
  Object.entries(statusColor).map(([k, v]) => [k, v.hex])
);
